// extracted by mini-css-extract-plugin
export default {"noNetworkContainer":"NoNetworkScreen_noNetworkContainer__Bb8NE","icon":"NoNetworkScreen_icon__3LLY7"};